import { inject, Injectable } from '@angular/core';
import { DataStore } from '../../storage/data-store/data-store';
import { StoreBatchWeighingSaveInfo } from '../../storage/data-store/model/store-batch-weighing-save-info';
import { SaveToDataStoreMapper } from '../../mappers/data-store/save-to-data-store.mapper';
import { ViewModelsToDataStoreMapper } from '../../mappers/data-store/viewmodels-to-data-store.mapper';
import { RemovalSaveInfoViewModel } from '../../viewmodels/shared/removal-save-info.viewmodel';

@Injectable({
  providedIn: 'root',
})
export class RegistrationStoreWriterService {
  private readonly store = inject(DataStore);
  private readonly saveToDataMapper = inject(SaveToDataStoreMapper);
  private readonly viewModelsMapper = inject(ViewModelsToDataStoreMapper);

  constructor() {}

  storeBatchWeighing(weighingSave: StoreBatchWeighingSaveInfo): void {
    const newBatchWeighing = this.saveToDataMapper.createUpdatedBatchWeighing(weighingSave);
    this.store.storeUpdateAllBatchWeighings([newBatchWeighing], this.store.batchWeighings);
  }

  storeAnimalWeighings(weighingSave: StoreBatchWeighingSaveInfo): void {
    const newAnimalWeighings = this.saveToDataMapper.createUpdatedAnimalWeighings(weighingSave);
    this.store.storeUpdateAllAnimalWeighings(newAnimalWeighings, this.store.animalWeghings);
  }

  storeRemovals(removalSaveInfos: RemovalSaveInfoViewModel[]): void {
    const newRemovals = this.viewModelsMapper.createUpdatedRemovals(removalSaveInfos);
    this.store.storeUpdateAllRemovals(newRemovals, this.store.removals);
  }

  clear(): void {
    this.store.clear();
  }
}
